angular.module('rightPaneModule')
    .directive('dblStandardActivity', ['$compile', '$log', 'navigation', '$filter', 'customer', function($compile, $log, dblNavigation, $filter, customer) {
        return {
            restrict: 'E',
            templateUrl: '/resources/right-pane/components/activity-feed/dbl-standard-activity.directive.html',
            scope: {
                dblActivity: '=',
                dblShowStudentName: '=',
              dblUseUxEaseOfUse: '='
            },
            link: function(scope, element) {

              scope.oldTemplateUrl = '/resources/right-pane/components/activity-feed/old-activity-templates/dbl-standard-activity.directive.html';

              scope.isAstUk = customer.isAstUk();

              scope.getLessonStatusText = function () {
                    return $filter('translate')('standards.completedStandardWith');
                };

                scope.getUnderstandingText = function () {
                    return $filter('translate')('standards.proficiency');
                };

                scope.getUnderstandingClass = function () {
                    return 'activity-tone-good';
                };

                scope.studentClicked = function() {
                  var studentId = scope.dblActivity.id;
                  var student = {
                    id: studentId,
                    type: 'student'
                  };
                  var overrideParams = {
                    pane: 'activity'
                  };

                  dblNavigation.goToItem(student, overrideParams);
                };
            }
        };
    }]);
